var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$route.path)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }